import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { TestingLab, useTestingLabsContext } from '../../TestingLabsContext'
import { useRemoveTestingLabMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'

export function useRemove(): RemoveRowActionOptions<TestingLab> {
  const { refetch } = useTestingLabsContext()
  const [remove] = useRemoveTestingLabMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      removeTestingLab: {
        testingLab: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveTestingLab,
    hard: true,
    disabled: ({ concreteCoreBreakDatas, concreteTestBreakDatas, labTechs }) =>
      !!concreteCoreBreakDatas.length ||
      !!concreteTestBreakDatas.length ||
      !!labTechs.length
        ? {
            message:
              'Testing Labs cannot be removed if they are associated with any Lab Techs or Break Data',
          }
        : false,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
